import {Model} from '@vuex-orm/core';
import {ISchool} from '../../interfaces/commons/ISchool';

// @ts-ignore
export default class School extends Model implements ISchool {
    static entity = 'schools';

    static fields () {
        return {
            id: this.number(null),
            cod: this.number(null),
            name: this.string(''),
            logo: this.string('').nullable(),
            yearSelected: this.string(''),
        };
    }
}
